import Abstract from './abstract';
import Body from '../body';

export default () => {
  const steps = [
    {
      selector: '[data-guide="course-edit@editing"]',
      content: <Body title="切换到编辑状态可以编辑" description="锁定-编辑状态 可以进行内容更新" />,
    },
    {
      selector: '[data-guide="course-edit@editing"]',
      content: (
        <Body
          title="切换到锁定状态锁定内容"
          description="编辑中-锁定 确认内容更新，发布后更新内容同步出现在爱课件中"
        />
      ),
    },
  ];

  return <Abstract steps={steps} scene="editLock" />;
};
